import { Button } from "@/components/ui/button";
import { Fire, Timer } from "@phosphor-icons/react";

export function LifetimeClaimBanner({ offer, countdown, busy, onClaim }) {
  return (
    <div data-testid="lifetime-claim-banner" className="mb-6 rounded-xl p-5 ring-1 ring-amber-500/30 bg-gradient-to-r from-amber-500/[0.1] to-transparent animate-offer-glow">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span className="rounded-full bg-amber-500 text-black text-[10px] font-extrabold uppercase tracking-wider px-2 py-0.5 flex items-center gap-1"><Fire size={11} weight="fill" /> Limited time</span>
            {countdown && <span className="font-mono text-xs text-amber-300 flex items-center gap-1"><Timer size={13} weight="bold" /> ends in {countdown}</span>}
          </div>
          <div className="font-heading text-lg font-bold text-white">
            {offer.plan_name} Lifetime — <span className="text-amber-400">${offer.price} once</span>
            <span className="ml-2 text-sm text-zinc-400 line-through">${offer.regular_price}/mo</span>
          </div>
          <div className="text-xs font-mono text-red-400 mt-1">Only {offer.spots_left} of {offer.spots_total} licenses left · pay once, keep it forever</div>
        </div>
        <Button
          data-testid="claim-lifetime-btn"
          onClick={onClaim}
          disabled={busy === "lifetime"}
          className="bg-amber-500 text-black hover:bg-amber-400 font-bold shrink-0"
        >
          {busy === "lifetime" ? "Starting…" : "Claim lifetime deal"}
        </Button>
      </div>
    </div>
  );
}
